var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items.length > 0)?_c('GanttElastic',{ref:"timeline",attrs:{"tasks":_vm.items,"options":_vm.options,"dynamic-style":_vm.dynamicStyle},on:{"chart-task-click":_vm.taskClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }